import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface SitePreferencesUploadResults {
  sitePreferencesResults?: Array<{
    siteId: number | string
    siteName: string
  }>
  errors?: Array<{
    siteId: number | string
    siteName: string
    rowNumber?: number
    error: string
  }>
}

export interface SitePreferencesManagerState {
  file: File | null
  fileName: string
  uploadResults: SitePreferencesUploadResults | null
  isLoading: boolean
  error: string | null
}

const initialState: SitePreferencesManagerState = {
  file: null,
  fileName: '',
  uploadResults: null,
  isLoading: false,
  error: null,
}

const slice = createSlice({
  name: 'SitePreferencesManager',
  initialState,
  reducers: {
    setSelectedFile(state, action: PayloadAction<File | null>) {
      state.file = action.payload
      state.fileName = action.payload ? action.payload.name : ''
    },
    setIsSubmitting(state) {
      state.isLoading = true
      state.error = null
      state.uploadResults = null
    },
    setSubmittingSuccess(
      state,
      action: PayloadAction<{
        data?: {
          sitePreferencesResults?: Array<{
            siteId: number | string
            siteName: string
          }>
          errors?: Array<{
            siteId: number | string
            siteName: string
            rowNumber?: number
            error: string
          }>
        }
        file?: File
      }>,
    ) {
      const { data, file } = action.payload
      state.file = file || state.file
      state.fileName = file ? file.name : state.fileName
      state.uploadResults = data || null
      state.isLoading = false
      state.error = null
    },
    setSubmittingError(
      state,
      action: PayloadAction<{ error: string; file: File | null }>,
    ) {
      state.isLoading = false
      state.error = action.payload.error
      state.file = action.payload.file || state.file
      state.fileName = action.payload.file
        ? action.payload.file.name
        : state.fileName
      state.uploadResults = null
    },
  },
})

export const actions = slice.actions
export default slice.reducer
